var checkoutScheduledReplenishment = {
	autoReplenishOrder: "Auto Replenish Order",
	orderType_PLACE_ORDER: "None (one time order only)",
	orderType_SCHEDULE_REPLENISHMENT_ORDER: "Replenish Order",
	every: "Every",
	recurrencePeriodType_DAILY: "Day(s)",
	recurrencePeriodType_WEEKLY: "Week(s)",
	recurrencePeriodType_MONTHLY: "Month",
	dayOfMonth: "On day",
	startOn: "Start on",
	repeatOnDays: "Repeat on the following days",
	duration: "Duration"
};
var checkoutScheduledReplenishment$1 = {
	checkoutScheduledReplenishment: checkoutScheduledReplenishment
};

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const en = {
    checkoutScheduledReplenishment: checkoutScheduledReplenishment$1,
};

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const checkoutScheduledReplenishmentTranslations = {
    en,
};
const checkoutScheduledReplenishmentTranslationChunksConfig = {
    checkoutScheduledReplenishment: ['checkoutScheduledReplenishment'],
};

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { checkoutScheduledReplenishmentTranslationChunksConfig, checkoutScheduledReplenishmentTranslations };
